var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noContent"},[_c('img',{attrs:{"src":require("@img/xueyezixun/public/no_content2.png"),"alt":""}}),_c('div',{staticStyle:{"font-size":"18px","text-align":"center","color":"#333"}},[_vm._v("暂无学生档案")])])
}]

export { render, staticRenderFns }